import React from 'react'
import { Checkbox, Tooltip } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'
let i18n = content('transfer/inc/donateAnonymousCheckbox')
import { connect } from 'transfer/utils/p2p-connect'
import { changeDonationAnonymousStatus } from '../../actions/donate'
import { fetchFundingOptions } from '../../actions/send'

function DonateAnonymousCheckbox({
  donationAnonymousStatus,
  handleDonationAnonymousStatusChange,
  reFetchFundingOptions,
  country,
  isRecurring,
}) {
  const handleChange = event => {
    const isChecked = event.target.checked,
      checkboxStatus = isChecked ? 'checked' : ''
    handleDonationAnonymousStatusChange(checkboxStatus)
    reFetchFundingOptions()
  }

  const anonymousLabel =
    country === 'BR' ? i18n('anonymous.br.label') : i18n('anonymous.label')

  return (
    <div
      className={
        isRecurring
          ? 'rec-donate-anonymous-checkbox'
          : 'donate-anonymous-checkbox'
      }
    >
      <Checkbox
        theme="v2"
        id="donate-anonymous-checkbox"
        label={anonymousLabel}
        checked={donationAnonymousStatus}
        value={donationAnonymousStatus}
        onChange={handleChange}
        name="check2"
        labelIcon={
          <Tooltip
            className="donate-anonymous-checkbox-tooltip"
            theme="v2"
            name="anonymous-checkbox-tooltip"
            description={i18n('anonymous.tooltip')}
          />
        }
      />
    </div>
  )
}

DonateAnonymousCheckbox.propTypes = {
  donationAnonymousStatus: PropTypes.bool,
  handleDonationAnonymousStatusChange: PropTypes.func,
  reFetchFundingOptions: PropTypes.func,
  country: PropTypes.string,
  isRecurring: PropTypes.bool,
}

export default connect(
  ({ donate }) => ({
    donationAnonymousStatus: donate.donationAnonymousStatus,
    country: donate.country,
    isRecurring: donate.isRecurring,
  }),
  dispatch => ({
    handleDonationAnonymousStatusChange: donationAnonymousStatus =>
      dispatch(changeDonationAnonymousStatus(donationAnonymousStatus)),
    reFetchFundingOptions: () => dispatch(fetchFundingOptions()),
  })
)(DonateAnonymousCheckbox)
